"use client";

import { Button } from "@/components/ui/button";

type ProcessBlockProps = {
  content: {
    howServiceWorkTtile: string;
    howServiceWorkDescription: string;
    serviceButtonText: string;
    howServiceWorkGrid: {
      fields: {
        serviceName: string;
        serviceDescriptions: string;
      };
    }[];
  };
};

export default function ProcessBlock({ content }: ProcessBlockProps) {
  return (
    <div className="container mx-auto pt-20">
      <div className="w-full text-center mb-12">
        <h2 className="text-[40px] font-medium">{content.howServiceWorkTtile}</h2>
        <div className="max-w-[780px] mx-auto text-gray-600 mt-4">
          {content.howServiceWorkDescription}
        </div>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-6 justify-items-center">
        {content.howServiceWorkGrid.map((item, index) => (
          <div key={index} className="w-full max-w-[352px] flex">
            <div className="w-[48px] h-[48px] rounded-full bg-[#4381E5] text-white font-bold text-lg flex items-center justify-center">
              {index + 1}
            </div>
            <div className="w-[280px] ml-6">
              <div className="text-2xl font-medium mb-2">
                {item.fields.serviceName}
              </div>
              <div className="text-gray-600 text-[14px]">
                {item.fields.serviceDescriptions}
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="pt-12 w-full text-center">
        <Button className="rounded-3xl text-[#4381E5] hover:bg-[#4381E5] hover:text-white h-[48px] border border-blue-500 px-6 bg-transparent font-semibold text-[16px]">
          {content.serviceButtonText}
        </Button>
      </div>
    </div>
  );
}